(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-gravur-product"]) return;
  try {
    
function maGravurInit(root=document){
 root.querySelectorAll('[data-ma-fields]').forEach(fields=>{
  if(fields.dataset.ready)return;fields.dataset.ready='true';
  const form=fields.closest('form');if(!form)return;fields.addEventListener('input',()=>{const output=form.querySelector('[data-ma-result]');if(output)output.hidden=true});
  const segmenter=typeof Intl.Segmenter==='function'?new Intl.Segmenter(undefined,{granularity:'grapheme'}):null;
  const length=value=>segmenter?Array.from(segmenter.segment(value)).length:Array.from(value).length;
  const validate=input=>{input.setCustomValidity('');if(input.disabled)return;const value=input.value.trim();
   if(input.required&&!value)input.setCustomValidity(fields.dataset.empty);
   else if(value&&length(value)>Number(input.dataset.maLimit))input.setCustomValidity(fields.dataset.long);
   else if(input.hasAttribute('data-ma-arabic')&&value&&!/[\u0621-\u064A\u066E-\u06D3\u06FA-\u06FC]/u.test(value)&&!fields.querySelector('[data-ma-unsure]')?.checked)input.setCustomValidity(fields.dataset.arabicError);
  };
  fields.querySelectorAll('[data-ma-limit]').forEach(input=>{input.addEventListener('input',()=>validate(input));input.addEventListener('blur',()=>{input.value=input.value.trim();validate(input)});});
  fields.querySelector('[data-ma-unsure]')?.addEventListener('change',event=>fields.querySelectorAll('[data-ma-arabic]').forEach(input=>{input.required=!event.target.checked;validate(input)}));
  const sizeSelector=fields.querySelector('[data-ma-size]');
  const price=form.closest('.ma-product')?.querySelector('[data-ma-price]');
  const basePrice=price?.textContent;
  const variants=JSON.parse(form.closest('.ma-product')?.querySelector('[data-ma-variants]')?.textContent||'[]');
  const variantInput=form.querySelector('input[name=id]');
  const submitButton=form.querySelector('button[type=submit]');
  const formatSelector=fields.querySelector('[data-ma-format]');
  const gallery=form.closest('.ma-product')?.querySelector('[data-ma-gallery]');
  const updateImage=()=>{const format=formatSelector?.selectedOptions[0].dataset.format;const url=gallery?.dataset[format];const img=gallery?.querySelector('img');if(url&&img){img.removeAttribute('srcset');img.src=url;}};
  const updatePrice=()=>{if(!price||!sizeSelector||!formatSelector)return;const count=Number(sizeSelector.selectedOptions[0].dataset.count);const format=formatSelector.selectedOptions[0].dataset.format;const variant=variants.find(v=>v.count===count&&v.format===format);price.textContent=variant?variant.price:price.dataset.maPending;if(price.nextElementSibling)price.nextElementSibling.hidden=!variant;if(variantInput){variantInput.value=variant?.id||'';submitButton.disabled=!variant?.available;}};
  updatePrice();updateImage();
  formatSelector?.addEventListener('change',()=>{updateImage();updatePrice();const result=form.querySelector('[data-ma-result]');if(result)result.hidden=true;});
  sizeSelector?.addEventListener('change',()=>{
   const count=Number(sizeSelector.selectedOptions[0].dataset.count);
   fields.querySelectorAll('[data-ma-coaster]').forEach(group=>{const active=Number(group.dataset.maCoaster)<=count;group.hidden=!active;group.querySelectorAll('input,textarea,select').forEach(input=>{input.disabled=!active;input.setCustomValidity('')});});
   const result=form.querySelector('[data-ma-result]');if(result)result.hidden=true;
   updatePrice();
  });
  form.addEventListener('submit',event=>{
   if(variantInput&&sizeSelector&&!variantInput.value){event.preventDefault();return;}
   fields.querySelectorAll('[data-ma-limit]').forEach(input=>{input.value=input.value.trim();validate(input)});
   if(!form.reportValidity()){event.preventDefault();event.stopImmediatePropagation();return;}
   if(form.hasAttribute('data-ma-demo')){event.preventDefault();const output=form.querySelector('[data-ma-result]');output.hidden=false;let lines=[];for(const [key,value] of new FormData(form))if(key.startsWith('properties[')&&value){const input=form.elements.namedItem(key);const property=key.slice(11,-1);const labels={'Schriftstil':fields.dataset.styleLabel,'Vorlagenprüfung':fields.dataset.proofLabel,'Angaben kontrolliert':fields.dataset.checkedLabel};const label=labels[property]||input?.labels?.[0]?.textContent.trim()||property;const shown=input?.tagName==='SELECT'?input.selectedOptions[0].textContent.trim():input?.type==='checkbox'?fields.dataset.yes:value;lines.push(label+': '+shown);};output.textContent=output.dataset.heading+'\n\n'+lines.join('\n');output.focus();}
  });
 });
}
maGravurInit();document.addEventListener('shopify:section:load',event=>maGravurInit(event.target));

  } catch(e) { console.error(e); }
})();
})();
